import { useState, useEffect, useMemo, createContext } from "react";
import api from "./meetingApi";
import { Meeting, Workspace } from "../lib/cnb/api/public";

export const useMeeting = (workspace?: Workspace) => {
  const [meetings, setMeetings] = useState<Meeting[]>([]);

  useEffect(() => {
    if (!workspace) {
      setMeetings([]);
      return;
    }

    const fetchMeetings = async () => {
      const ms = await api.getAllMeetings(workspace.id);
      setMeetings(ms);
    };
    fetchMeetings();
  }, [workspace]);

  return useMemo(
    () => ({
      meetings,
    }),
    [meetings],
  );
};

export const MeetingContext = createContext<ReturnType<typeof useMeeting>>(
  null as any,
);
